const ca = {
  common: {
    facts: "En xifres",
    why: "Per què triar l'Hotel Ciutat Martorell",
    related: "També et pot interessar",
    quoteEyebrow: "Explica'ns el vostre casament",
  },
  nearSeat: {
    seoTitle: "Hotel a prop de SEAT-CUPRA Martorell · a 5 min de la fàbrica",
    seoDesc: "Hotel 4★ a 5 minuts de la fàbrica SEAT-CUPRA i dels polígons de Martorell. Tarifes corporatives, WiFi de fibra, pàrquing, restaurant i tren a 100 m.",
    eyebrow: "Hotel per a visites a SEAT-CUPRA",
    title: ["El teu hotel a 5 minuts", "de SEAT-CUPRA Martorell"],
    intro: "Proveïdors, enginyers, formadors i equips de projecte s'allotgen amb nosaltres perquè la fàbrica i els polígons de Martorell són a tocar, i el tren a Barcelona a 100 metres.",
    facts: [
      { k: "Fàbrica SEAT-CUPRA", v: "5 min en cotxe" },
      { k: "Renfe i FGC", v: "100 m" },
      { k: "Barcelona", v: "30 min" },
      { k: "Aeroport del Prat", v: "25 min" },
    ],
    sections: [
      { h: "Pensat per a l'estada de feina", p: "Habitacions de 21 m² amb escriptori, WiFi de fibra gratuït i climatització. Esmorzar bufet de 06:30 a 10:30 per arribar a temps al torn de matí, recepció 24 h per a arribades tardanes i Business Corner per imprimir o tancar un informe." },
      { h: "Tarifes corporatives i facturació centralitzada", p: "Per a empreses que visiten la planta amb regularitat oferim tarifes negociades, facturació centralitzada i gestió àgil de les reserves d'equips. Explica'ns el volum aproximat de nits i et preparem una proposta." },
      { h: "Reunions i formacions al costat de la fàbrica", p: "Tres sales amb llum natural de 35 a 220 m² per a formacions de proveïdors, kick-offs o auditories, amb projector, fibra i coffee break. I el restaurant My Bar per a dinars de feina, amb menú executiu de dilluns a divendres." },
    ],
    why: [
      "A 5 minuts en cotxe de la fàbrica SEAT-CUPRA i dels polígons de Martorell",
      "Pàrquing privat al mateix hotel (amb suplement)",
      "WiFi de fibra gratuït i escriptori a totes les habitacions",
      "Esmorzar des de les 06:30 i recepció 24 hores",
      "Tarifes corporatives amb facturació centralitzada",
    ],
    faqTitle: "Sobre allotjar-se a prop de SEAT-CUPRA",
    cta: { title: "Reserva directa o tarifa d'empresa", text: "Reserva al web oficial al millor preu garantit o sol·licita una tarifa corporativa per al teu equip.", secondary: "Tarifes per a empreses", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "Hotel per a empreses" },
      { to: "meetingRooms", label: "Sales de reunions" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "On allotjar-se si visites Martorell per feina" },
    ],
  },
  nearMontserrat: {
    seoTitle: "Hotel a prop de Montserrat · a 20 min del monestir",
    seoDesc: "Hotel 4★ a Martorell a 20 minuts en cotxe de Montserrat i amb tren FGC a 100 m cap al cremallera. Base còmoda per visitar el monestir i Barcelona.",
    eyebrow: "Hotel per visitar Montserrat",
    title: ["Montserrat a 20 minuts,", "Barcelona a 30"],
    intro: "Martorell és el punt mig perfecte: al matí el monestir i les muntanyes de Montserrat, a la tarda Barcelona. I a la nit, una habitació tranquil·la amb restaurant i pàrquing.",
    facts: [
      { k: "Monestir de Montserrat", v: "20 min en cotxe" },
      { k: "Tren FGC al cremallera", v: "a 100 m de l'hotel" },
      { k: "Barcelona", v: "30 min" },
      { k: "Aeroport del Prat", v: "25 min" },
    ],
    sections: [
      { h: "Com arribar a Montserrat des de l'hotel", p: "En cotxe, 20 minuts fins al monestir o fins a l'aparcament del cremallera a Monistrol. En transport públic, l'estació d'FGC és a 100 metres: línia R5 fins a Monistrol de Montserrat i pujada en cremallera, o fins a Montserrat-Aeri i pujada en telefèric." },
      { h: "Un dia a la muntanya, una nit de descans", p: "Després de la basílica, l'Escolania o una caminada fins a Sant Jeroni, torna a una habitació de 21 m² amb climatització, bany amb dutxa i WiFi de fibra. Sopa al restaurant My Bar amb cuina mediterrània de mercat i vins del Penedès." },
      { h: "Combina Montserrat amb Barcelona", p: "Des de les estacions de Renfe i FGC, Barcelona és a uns 30 minuts. Pots dedicar un dia a Montserrat i un altre a la ciutat sense canviar d'hotel ni barallar-te amb l'aparcament del centre." },
    ],
    why: [
      "A 20 minuts en cotxe del monestir de Montserrat",
      "Estació d'FGC a 100 metres amb connexió al cremallera i al telefèric",
      "Pàrquing privat per deixar el cotxe i moure's en tren",
      "Restaurant My Bar amb cuina mediterrània i vins del Penedès",
      "Esmorzar bufet de 06:30 a 10:30 per matinar a la muntanya",
    ],
    faqTitle: "Sobre visitar Montserrat des de l'hotel",
    cta: { title: "Reserva la teva base per a Montserrat", text: "Reserva directa al web oficial al millor preu garantit. Si veniu en grup, demaneu-nos una proposta.", secondary: "Com arribar a l'hotel", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "Com arribar a Montserrat des de Martorell" },
      { to: "location", label: "Ubicació i com arribar" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "Què visitar a prop de Martorell" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "Hotel amb pàrquing a prop de Barcelona · a 30 min en tren",
    seoDesc: "Hotel 4★ amb pàrquing privat a Martorell, a 30 minuts de Barcelona. Deixa el cotxe i entra a la ciutat amb Renfe o FGC des de l'estació a 100 m. Reserva directa.",
    eyebrow: "Hotel amb pàrquing",
    title: ["Aparca el cotxe,", "Barcelona en 30 minuts"],
    intro: "Si arribes en cotxe a Barcelona, dormir fora del centre és més tranquil i senzill: pàrquing privat a l'hotel i tren directe a la ciutat a 100 metres de la porta.",
    facts: [
      { k: "Pàrquing privat", v: "a l'hotel" },
      { k: "Estacions Renfe i FGC", v: "100 m" },
      { k: "Barcelona centre", v: "30 min" },
      { k: "Aeroport del Prat", v: "25 min" },
    ],
    sections: [
      { h: "Pàrquing privat al mateix hotel", p: "Places d'aparcament privat per a clients allotjats (amb suplement), sense buscar lloc ni pagar les tarifes dels pàrquings del centre de Barcelona. Entres i surts quan vols i el cotxe queda a dues passes de l'habitació." },
      { h: "A Barcelona en tren, sense trànsit", p: "Les estacions de Renfe (Rodalies) i FGC són a 100 metres. En uns 30 minuts ets al centre; a la tornada, el cotxe t'espera. Per moure't per la província, l'A-2 i l'AP-7 són al costat." },
      { h: "Un hotel complet per a l'escapada", p: "92 habitacions de 21 m² amb WiFi de fibra, restaurant My Bar, gimnàs i esmorzar bufet de 06:30 a 10:30. Ideal per a famílies i parelles que visiten Barcelona o Montserrat en cotxe." },
    ],
    why: [
      "Pàrquing privat per a hostes a l'hotel",
      "Trens a Barcelona a 100 metres: Renfe i FGC",
      "A 30 minuts de Barcelona i 25 de l'aeroport",
      "Habitacions Doble i Twin de 21 m² amb WiFi de fibra",
      "Restaurant, gimnàs i recepció 24 h",
    ],
    faqTitle: "Sobre el pàrquing i com anar a Barcelona",
    cta: { title: "Reserva amb pàrquing i oblida't del cotxe", text: "Reserva directa al web oficial al millor preu garantit i indica'ns si véns en cotxe.", secondary: "Serveis de l'hotel", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "Com anar de Martorell a Barcelona" },
      { to: "services", label: "Serveis de l'hotel" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "Transports entre Martorell i Barcelona" },
    ],
  },
  weddingsBaix: {
    seoTitle: "Hotel per a casaments al Baix Llobregat · Martorell",
    seoDesc: "Celebra el teu casament a Martorell: Saló de Banquets fins a 150 convidats, còctel fins a 200 a la terrassa, menú degustació, habitació nupcial i tarifes per a convidats.",
    eyebrow: "Casaments al Baix Llobregat",
    title: ["El vostre casament al Baix Llobregat,", "amb tot sota un mateix sostre"],
    intro: "Còctel a la terrassa, banquet en un saló de 220 m² amb llum natural, cuina mediterrània pròpia i 92 habitacions perquè ningú hagi de conduir de tornada. A 30 minuts de Barcelona i ben comunicat amb tota la comarca.",
    facts: [
      { k: "Banquet", v: "fins a 150 convidats" },
      { k: "Còctel", v: "fins a 200 persones" },
      { k: "Saló de Banquets", v: "220 m² amb llum natural" },
      { k: "Habitacions", v: "92 per als convidats" },
    ],
    sections: [
      { h: "Espais: terrassa, saló i habitacions", p: "El còctel de benvinguda a la terrassa, el banquet al Saló de Banquets panelable de 220 m² i, en acabar, l'habitació nupcial de cortesia i tarifes especials per als convidats que es quedin a dormir." },
      { h: "Cuina pròpia i menú degustació", p: "El nostre equip de cuina prepara menús de casament a mida amb producte mediterrani de temporada i vins del Penedès. Abans del gran dia organitzem una degustació per tancar cada plat amb els nuvis." },
      { h: "Un coordinador des del primer cafè", p: "Pressupost tancat en 48 hores, sense sorpreses. Un coordinador dedicat gestiona temps, proveïdors, DJ i barra lliure opcional perquè la parella només hagi de gaudir." },
    ],
    why: [
      "Ben comunicat per a convidats de Barcelona i de tota la comarca: 30 min en cotxe i tren a 100 m",
      "Saló de 220 m² amb llum natural i terrassa per al còctel",
      "Habitació nupcial de cortesia i tarifes especials per a convidats",
      "Menú degustació previ i cuina mediterrània pròpia",
      "Coordinador dedicat i pressupost tancat en 48 hores",
    ],
    faqTitle: "Sobre celebrar el casament a l'hotel",
    cta: { title: "Explica'ns com imagineu el vostre casament", text: "Digueu-nos la data aproximada, el nombre de convidats i què teniu al cap; us responem amb una proposta en 48 hores." },
    related: [
      { to: "weddings", label: "Casaments a l'hotel" },
      { to: "events", label: "Esdeveniments i celebracions" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "Saló de Banquets" },
    ],
  },
};

export default ca;
